/* Gallery only: no form, storage, network or analytics behaviour. */
if (!customElements.get('gc26-service-gallery')) {
  customElements.define('gc26-service-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      if (!this.slides.length) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.thumbnails = [...this.querySelectorAll('[data-thumbnail]')];
      this.index = 0;
      this.setAttribute('data-ready', '');
      this.querySelectorAll('[data-direction], .gcs-thumbs').forEach(el => { el.hidden = false; });
      this.querySelectorAll('[data-direction]').forEach(button => {
        button.addEventListener('click', () => this.show(this.index + Number(button.dataset.direction)), options);
      });
      this.thumbnails.forEach((button, index) => button.addEventListener('click', () => this.show(index), options));
      const surface = this.querySelector('.gcs-slides');
      surface.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      let start = null;
      surface.addEventListener('pointerdown', event => {
        if (!event.isPrimary || event.pointerType === 'mouse' || event.target.closest('button')) return;
        start = { x: event.clientX, y: event.clientY, id: event.pointerId };
      }, options);
      surface.addEventListener('pointerup', event => {
        if (!start || start.id !== event.pointerId) return;
        const dx = event.clientX - start.x, dy = event.clientY - start.y;
        start = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) this.show(this.index + (dx < 0 ? 1 : -1));
      }, options);
      surface.addEventListener('pointercancel', () => { start = null; }, options);
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.show(index);
      }, options);
      this.show(0, false);
    }
    show(requested, animate = true) {
      const index = (requested + this.slides.length) % this.slides.length;
      const direction = requested < this.index ? 'gcs-backward' : 'gcs-forward';
      this.slides.forEach((slide, i) => {
        slide.hidden = i !== index;
        slide.classList.remove('gcs-forward', 'gcs-backward');
        if (i === index && animate && index !== this.index) slide.classList.add(direction);
      });
      this.thumbnails.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      const status = this.querySelector('[data-gallery-status]');
      if (status) status.textContent = `Photograph ${index + 1} of ${this.slides.length}`;
      this.index = index;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}
